import { render, staticRenderFns } from "./WhyDifficulties.vue?vue&type=template&id=6ffe4a2e&"
import script from "./WhyDifficulties.vue?vue&type=script&lang=js&"
export * from "./WhyDifficulties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports